import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Card, Chiclet } from 'components'

export const MenuChiclet = styled(Chiclet)`
  z-index: 99999;
`

export const Container = styled.div`
  border: 0 none;
  width: 100vw;
  height: 100%;
  max-height: 100vh;
  min-height: 90vh;
  margin: 0;
  padding: 0;
  overflow: auto;
  overflow-x: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-content: stretch;
  justify-content: flex-start;
  & > ${Card} {
    padding-bottom: 3.5rem;
  }
`

export const Header = styled.div`
  height: 4.5rem;
  max-height: 4.5rem;
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex: 1;
`

export const ModalOverlay = styled.div`
  ${({ $show, theme: { colors } }) => `
  display: ${$show ? 'flex' : 'none'};
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: ${colors('foreground', 0.25)};
  backdrop-filter: blur(4px);
  `}
`

export const MenuContainer = styled.div`
  ${({ $show, theme: { colors } }) => `
  flex: 1;
  display: ${$show ? 'flex' : 'none'};
  position: fixed;
  top:0;
  bottom: 0;
  padding-bottom: 3.5rem;
  right: 0;
  height: auto;
  width: 60vw;
  z-index: 999;
  background: ${colors('chrome', 0.75)};
  backdrop-filter: blur(6px);
  color: ${colors('foreground')};
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 2px 0px 30px 0px ${colors('shadow', 0.5)};
  `}
  @media (max-width: 480px) {
    width: 85vw;
    padding-bottom: calc(3.5rem + env(safe-area-inset-bottom, 0px));
  }
`

export const MenuToggle = styled.div`
  ${({ theme: { colors } }) => `
  position: absolute;
  bottom: 0;
  right: 0.5rem;
  width: 3.5rem;
  height: 3.5rem;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: env(safe-area-inset-bottom, 0px);
`}
`

export const MenuItem = styled.div`
  ${({ theme: { colors } }) => `
    color: ${colors('text')};
    border-bottom: 1px solid ${colors('text', 0.25)};
    width: 100%;
    display: inline-flex;
    justify-content: flex-end;
  `}
`

export const MenuOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  ${({ $show, theme: { colors } }) => `
    display: ${$show ? 'block' : 'none'};
    background: ${colors('foreground', 0.175)};
    backdrop-filter: blur(6px);
  `}
`

export const MenuLink = styled(Link)`
  padding: 1rem;
`

export const MenuSubItem = styled.div`
  ${({ theme: { colors } }) => `
    color: ${colors('text')};
    border-bottom: 1px solid ${colors('text', 0.15)};
    width: 100%;
    display: inline-flex;
    justify-content: flex-end;
  `}
`

export const MenuSubLink = styled(Link)`
  padding: 0.6rem 1rem 0.6rem 2rem;
  font-size: 0.9em;
  opacity: 0.8;
`

export const MenuGroupLabel = styled.div`
  ${({ theme: { colors } }) => `
    color: ${colors('text', 0.5)};
    border-bottom: 1px solid ${colors('text', 0.25)};
    width: 100%;
    display: inline-flex;
    justify-content: flex-end;
    padding: 1rem;
    font-size: 0.8em;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    pointer-events: none;
  `}
`

export const MenuSection = styled.div`
  flex: 1;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const Nav = styled.div`
  display: flex;
  position: absolute;
  bottom: 0;
  left: 0;
  width: auto;
  height: 3.5rem;
  z-index: 9999;
  align-items: center;
  padding: 0 1rem;
  padding-bottom: env(safe-area-inset-bottom, 0px);
`
